<template>
  <div
    :class="['cf-notification', {
      'cf-notification--info': notificationType === 'info',
      'cf-notification--success': notificationType === 'success',
      'cf-notification--error': notificationType === 'error',
      'cf-notification--clickable': hasNavigation
    }]"
    @click="notificationClickHandler"
  >

    <button
      v-if="canDismiss"
      id="notification-close-btn"
      type="button"
      class="cf-icon cf-icon--smedium fal fa-times cursor-pointer"
      title="Close loyalty summary"
      @click.stop="closeClickHandler"
    />

    <slot />
  </div>
</template>

<script>
  export default {
    name: 'CfNotificationPopUp',

    props: {
      notificationType: {
        type: String,
        required: true
      },

      canDismiss: {
        type: Boolean,
        default: false
      },

      hasNavigation: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      notificationClickHandler() {
        this.$emit('notification-click');
      },

      closeClickHandler() {
        this.$emit('close-notification');
      }
    }
  };
</script>
